import { useState, useEffect } from 'react';

interface NavbarProps {
  activeSection: string;
}

export default function Navbar({ activeSection }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'services', label: 'Services' },
    { id: 'portfolio', label: 'Portfolio' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <a
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection('home');
            }}
            className="flex items-center cursor-pointer"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/c8e34b09-b347-46a2-a488-5136eef1d3d9.png"
              alt="Siriux Digital Logo"
              className="h-10 w-auto"
            />
          </a>

          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.id);
                }}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  activeSection === item.id
                    ? isScrolled
                      ? 'text-teal-600'
                      : 'text-white'
                    : isScrolled
                    ? 'text-gray-700 hover:text-teal-600'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>

          <button
            onClick={() => scrollToSection('contact')}
            className={`hidden md:block px-6 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
              isScrolled
                ? 'bg-teal-600 text-white hover:bg-teal-700'
                : 'bg-white text-teal-600 hover:bg-white/90'
            }`}
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}
